import React from 'react';

const FormStep = ({ stepName, children, formik, style }) =>
    React.cloneElement(children, {
        formik,
        style: { ...children.props.style, ...style } // Merge existing styles with new ones
    });

export default FormStep;
